import { render, staticRenderFns } from "./CalendarWeek.vue?vue&type=template&id=65043092&"
import script from "./CalendarWeek.vue?vue&type=script&lang=js&"
export * from "./CalendarWeek.vue?vue&type=script&lang=js&"
import style0 from "./CalendarWeek.vue?vue&type=style&index=0&id=65043092&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports